import {
    Package,
    IndianRupee,
    Percent,
    Truck,
    BadgePercent,
    Receipt,
    FileText,
} from "lucide-react";
import getImageUrl from "../../../utils/imageUrl";
import "./OverviewTab.css";

function OverviewTab({ order }) {

    return (

        <div className="overview-tab">

            {/* ===========================================
                    ORDER ITEMS
            =========================================== */}

            <div className="overview-card">

                <div className="overview-title">

                    <Package size={22} />

                    <h2>Ordered Food Items</h2>

                </div>

                <div className="items-list">

                    {order.items?.map((item, index) => (

                        <div
                            key={index}
                            className="item-card"
                        >

                         <img
    src={
        item.image
            ? getImageUrl(item.image)
            : "/images/food-placeholder.png"
    }
    alt={item.foodName || "Food"}
    onError={(event) => {
        event.currentTarget.src =
            "/images/food-placeholder.png";
    }}
/>

                            <div className="item-details">

                                <h3>

                                    {item.foodName}

                                </h3>

                                <p>

                                    Quantity :
                                    {" "}
                                    <strong>

                                        {item.quantity}

                                    </strong>

                                </p>

                                <p>

                                    Price :
                                    {" "}
                                    ₹

                                    {Number(
                                        item.price
                                    ).toLocaleString("en-IN")}

                                </p>

                            </div>

                            <div className="item-total">

                                ₹

                                {Number(
                                    item.total
                                ).toLocaleString("en-IN")}

                            </div>

                        </div>

                    ))}

                </div>

            </div>

            {/* ===========================================
                     BILL SUMMARY
            =========================================== */}

            <div className="overview-card">

                <div className="overview-title">

                    <Receipt size={22} />

                    <h2>Bill Summary</h2>

                </div>

                <div className="bill-summary">

                    <div>

                        <span>

                            <IndianRupee size={16}/>

                            Sub Total

                        </span>

                        <strong>

                            ₹{order.subTotal}

                        </strong>

                    </div>

                    <div>

                        <span>

                            <Percent size={16}/>

                            GST

                        </span>

                        <strong>

                            ₹{order.gst}

                        </strong>

                    </div>

                    <div>

                        <span>

                            <Package size={16}/>

                            Packing Charge

                        </span>

                        <strong>

                            ₹{order.packingCharge}

                        </strong>

                    </div>

                    <div>

                        <span>

                            <Truck size={16}/>

                            Delivery Charge

                        </span>

                        <strong>

                            ₹{order.deliveryCharge}

                        </strong>

                    </div>

                    <div>

                        <span>

                            <BadgePercent size={16}/>

                            Platform Fee

                        </span>

                        <strong>

                            ₹{order.platformFee}

                        </strong>

                    </div>

                    <div>

                        <span>

                            Discount

                        </span>

                        <strong className="discount">

                            -₹{order.discount}

                        </strong>

                    </div>

                    <div className="grand-total">

                        <span>

                            Grand Total

                        </span>

                        <strong>

                            ₹

                            {Number(
                                order.grandTotal
                            ).toLocaleString("en-IN")}

                        </strong>

                    </div>

                </div>

            </div>

            {/* ===========================================
                    COUPON
            =========================================== */}

            <div className="overview-card">

                <div className="overview-title">

                    <BadgePercent size={22}/>

                    <h2>Coupon Details</h2>

                </div>

                <div className="coupon-box">

                    {order.couponCode ?

                        <>

                            <h3>

                                {order.couponCode}

                            </h3>

                            <p>

                                Coupon applied successfully.

                            </p>

                        </>

                        :

                        <p>

                            No coupon applied.

                        </p>

                    }

                </div>

            </div>

            {/* ===========================================
                   CUSTOMER NOTE
            =========================================== */}

            <div className="overview-card">

                <div className="overview-title">

                    <FileText size={22}/>

                    <h2>Customer Note</h2>

                </div>

                <div className="note-box">

                    {

                        order.addressSnapshot?.customerNote ||

                        "No special instructions provided."

                    }

                </div>

            </div>

        </div>

    );

}

export default OverviewTab;